import { Config } from 'config'

const config: Partial<Config> = {
  env: 'local',
  basePath: '/site/',
  basename: '/site',
  routerPath: '/*',
}

export default config as Config
